export const isValidEmail = (email: string) =>
  /^[_A-Za-z0-9-.+]+@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/.test(
    email
  );
